import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
} from "@chakra-ui/react";
import Employee from "./Employee.css";
import { addEmployee } from "../../../redux/api/employeeApi/EmployeeApi.js";
import { addEmployeeAction } from "../../../redux/reduxSlice/EmployeeSlice.js";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { updateEmployee } from "../../../redux/api/employeeApi/EmployeeApi.js";
import { updateEmployeeAction } from "../../../redux/reduxSlice/EmployeeSlice.js";
import { NotificationSaveTokenApi } from "../../../Notification/NotificationApi.js";

// import Countries from '../../crm/Countries.js';
import { Countries } from "../../crm/Countries.js";
import "./Employee.css";

// Function to generate unique token string
const generateUniqueToken = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const firstPart = Array.from({length: 22}, () => 
    characters.charAt(Math.floor(Math.random() * characters.length))
  ).join('');
  
  const secondPart = Array.from({length: 152}, () => 
    characters.charAt(Math.floor(Math.random() * characters.length))
  ).join('');
  
  return `${firstPart}:APA91b${secondPart}`;
};

function EmployeeForm(props) {
const notificationToken = process.env.REACT_APP_COMMON_NOTIFICATION_TOKEN;

  const {
    isUpdateMode,
    dataToEdit,
    formData: initialFormData,
    setIsUpdateMode,
    employeeROWID,
    onNewEmployeeAdded,
  } = props;
  const dispatch = useDispatch();
  const roleList = useSelector((state) => state.utils.roleList);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [role, setRole] = useState([]);

  const roleData = useMemo(() => {
    return roleList.map((item) => ({
      label: item.roles.roleName,
      value: item.roles.ROWID,
    }));
  }, [JSON.stringify(roleList)]);

  useEffect(() => {
    setRole(roleData);
  }, [roleData]);
  
  const [formData, setFormData] = useState({
    employeeName: "",
    owner: "",
    email: "",
    currency: "",
    taxCode: "",
    iRDNumber: "",
    date: "",
    street: "",
    state: "",
    city: "",
    PinCode: "",
    country: "",
    dateOfBirth: "",
    otherContactDetail: "",
    startDate: "",
    bank: "",
    branch: "",
    phoneNumber: "",
    rate: "",
    timesheetLink: "",
    employeeStatus: "",
    worksheetLink: "",
    vehicleJobLink: "",
    driver: "",
    suffix: "",
    account: "",
    machineJobLink: "",
    nationality: "",
    confirmationDate: "",
    rateHour: "",
    permissions: null,
    department: null,
  });
  
  const departmentData = useSelector((state) => state?.utils?.departmentList);
  const [department, setDepartment] = useState("");

  const departmentLookup = useMemo(() => {
    return departmentData.map((item) => ({
      label: item?.departmentName,
      value: item?.ROWID,
    }));
  }, [JSON.stringify(departmentData)]);
  console.log("departmentLookup", departmentLookup);

  useEffect(() => {
    setDepartment(departmentLookup);
  }, [departmentLookup]);

  const countries = [...Countries];
  const { closeDrawer } = props;
  const [submitDisabled, setSubmitDisabled] = useState(false);
  
  const handleOnClose = () => {
    closeDrawer();
    setIsUpdateMode(false);
    setFormData({
      employeeName: "",
      owner: "",
      email: "",
      currency: "",
      taxCode: "",
      iRDNumber: "",
      date: "",
      street: "",
      state: "",
      city: "",
      PinCode: "",
      country: "",
      dateOfBirth: "",
      otherContactDetail: "",
      startDate: "",
      bank: "",
      branch: "",
      phoneNumber: "",
      rate: "",
      timesheetLink: "",
      employeeStatus: "",
      worksheetLink: "",
      vehicleJobLink: "",
      driver: "",
      suffix: "",
      account: "",
      machineJobLink: "",
      nationality: "",
      confirmationDate: "",
      rateHour: "",
      department: null,
      permissions: null,
    });
  };
  
  useEffect(() => {
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev,
        ...props.dataToEdit,
      }));
    }
  }, [isUpdateMode, dataToEdit]);

  // Function to call Notification API
  const callNotificationApi = async (email) => {
    try {
      // const token = generateUniqueToken();
      const token = notificationToken;
      const payload = {
        token: token,
        email: email
      };
      
      const response = await NotificationSaveTokenApi(payload);
      console.log("Notification API response:", response);
      return response;
    } catch (error) {
      console.error("Notification API error:", error);
      // Don't throw error here as we don't want to block the main operation
      return null;
    }
  };

  const handelOnUpdate = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    updateEmployee(formData)
      .then((response) => {
        console.log({ response });
        if (response.data.success) {
          setFormData((prev) => ({
            ...prev,
            ROWID: response?.data.ROWID,
          }));
          dispatch(updateEmployeeAction(formData));
          toast.success("Employee Updated SuccesFully !!");
          setShowProgressBar(false);

          // Call Notification API after successful update
          if (formData.email) {
            callNotificationApi(formData.email)
              .then(notificationResponse => {
                console.log("Notification sent after update:", notificationResponse);
              })
              .catch(error => {
                console.error("Failed to send notification after update:", error);
              });
          }
        }
        setTimeout(() => {
          handleOnClose();
          setShowProgressBar(false);
          setSubmitDisabled(false);
        }, 300);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Employee Updation Failed !");
      })
      .finally(() => {
        setSubmitDisabled(false);
      });
  };
  
  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? "silver" : "rgb(93, 135, 255)",
      borderRadius: "10px",
      border: "0.5px solid rgb(196,196,196,0.5) !important",
    }),

    placeholder: (styles) => ({
      ...styles,
      color: "gray",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      color: "black",
      backgroundColor: "white",
    }),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected
        ? "#f1e9e9;"
        : isFocused
        ? "#f1e9e9;"
        : "white",
      color: isSelected ? "#666" : "#333",
    }),
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      formData.employeeName === "" ||
      formData.owner === "" ||
      formData.permissions === ""
    ) {
      toast.error("Please fill all the required fields");
      return;
    }
    setShowProgressBar(true);
    addEmployee({...formData, createdBy: localStorage.getItem("email")})
      .then((response) => {
        console.log("Response - ", response);
        if (response.data.success) {
          const ROWID = response.data.ROWID;
          dispatch(addEmployeeAction({ ROWID, formData }));
          console.log(response);
          setShowProgressBar(false);
          toast.success("Employee added successfully!");
          
          // Call Notification API after successful creation
          if (formData.email) {
            callNotificationApi(formData.email)
              .then(notificationResponse => {
                console.log("Notification sent after creation:", notificationResponse);
              })
              .catch(error => {
                console.error("Failed to send notification after creation:", error);
              });
          }
          
          handleOnClose();
          setFormData();
          setShowProgressBar(false);
        } else {
          toast.error("Unable to add Employee , Please try again!");
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        toast.error("Failed to add Employee. Please try again.");
      });
  };

  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        placement="right"
        size="xl"
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            {isUpdateMode ? "Update Employee" : "Create Employee"}
          </DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme="pink" />}

            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>
              <div className="card">
                <div className="card-body">
                  <div className="row ">
                    <legend
                      style={{ fontSize: "Large" }}
                      className="sub-headers"
                    >
                      Employee Information
                    </legend>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Employee Name"
                          name="employeeName"
                          value={formData?.employeeName}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Employee Name<span style={{ color: "red" }}>*</span>
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder=" Owner"
                          name="owner"
                          value={formData?.owner}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Owner<span style={{ color: "red" }}>*</span>
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="email"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Email"
                          name="email"
                          value={formData?.email}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Email <span style={{ color: "red" }}>*</span>
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <select
                          className=" rounded"
                          type="text"
                          placeholder="Employee Status"
                          style={{ width: "100%", outline: "none" }}
                          name="employeeStatus"
                          value={formData?.employeeStatus}
                          onChange={handleChange}
                        >
                          <option value="None">None</option>
                          <option value="Underprocess">Underprocess</option>
                          <option value="Waiting on Document">
                            Waiting on Document
                          </option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "6px" }}
                      >
                        Employee Status
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="date"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Date Of Birth"
                          name="dateOfBirth"
                          value={formData?.dateOfBirth}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Date Of Birth
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Other Contact Detail"
                          name="otherContactDetail"
                          value={formData?.otherContactDetail}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Other Contact Detail
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="date"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Start Date ( with Numberdar )"
                          name="startDate"
                          value={formData?.startDate}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Start Date ( with Numberdar )
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="number"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Phone Number"
                          name="phoneNumber"
                          value={formData?.phoneNumber}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Phone Number
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="number"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Rate/Hour"
                          name="rateHour"
                          value={formData?.rateHour}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Rate/Hour
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <select
                          className=" rounded"
                          type="text"
                          placeholder="Nationality"
                          style={{ width: "100%", outline: "none" }}
                          name="nationality"
                          value={formData?.nationality}
                          onChange={handleChange}
                        >
                          <option value="None">None</option>
                          <option value="New Zealand">New Zealand</option>
                          <option value="India">India</option>
                          <option value="USA">USA</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "6px" }}
                      >
                        Nationality
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Select
                        name="permissions"
                        options={role}
                        defaultValue={
                          role &&
                          role?.find(
                            (item) => item.value === formData?.permissions
                          )
                        }
                        onChange={(option) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            permissions: option.value,
                          }));
                        }}
                        styles={{
                          ...customStyle,
                          menu: (provided) => ({ ...provided, maxHeight: 200 }),
                        }}
                      />
                      <FormLabel className="small-label ps-3">
                        {" "}
                        Permission <span style={{ color: "red" }}>*</span>
                      </FormLabel>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <Select
                        name="department"
                        options={departmentLookup}
                        defaultValue={
                          departmentLookup &&
                          departmentLookup?.find(
                            (item) => item.value === formData?.department
                          )
                        }
                        onChange={(option) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            department: option.value,
                          }));
                        }}
                        styles={{
                          ...customStyle,
                          menu: (provided) => ({ ...provided, maxHeight: 200 }),
                        }}
                      />

                      <FormLabel
                        className="small-label ps-3"
                        style={{ paddingLeft: "6px" }}
                      >
                        Department
                      </FormLabel>
                    </div>
                    
                  </div>
                </div>
                <label
                  htmlFor="imageUploadattachement"
                  className="image-upload card mt-2"
                  style={{
                    border: "2px dashed lightgrey",
                    borderRadius: "10px",
                    width: "100%",
                    height: "100px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="w-25 mx-auto">
                    <input
                      className="form-control"
                      type="file"
                      id="imageUpload"
                      name="leadAttachment"
                  
                      multiple
                    />
                    <div
                      className="image-upload-content"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <i
                        className="fas fa-cloud-upload-alt"
                        style={{ fontSize: "24px", marginBottom: "5px" }}
                      ></i>
                    </div>
                  </div>
                </label>
              </div>
              <div className="card mt-2">
                <div className="card-body">
                  <div className="row">
                    <legend
                      style={{ fontSize: "Large" }}
                      className="sub-headers"
                    >
                      Tax Information
                    </legend>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Tax Code"
                          name="taxCode"
                          value={formData?.taxCode}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Tax Code
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="IRD Number"
                          name="iRDNumber"
                          value={formData?.iRDNumber}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        IRD Number
                      </FormLabel>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mt-2">
                <div className="card-body">
                  <div className="row">
                    <legend
                      style={{ fontSize: "Large" }}
                      className="sub-headers"
                    >
                      Bank Details
                    </legend>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Bank"
                          name="bank"
                          value={formData?.bank}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">Bank</FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Branch"
                          name="branch"
                          value={formData?.branch}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">Branch</FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Account"
                          name="account"
                          value={formData?.account}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Account
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="text"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Suffix"
                          name="suffix"
                          value={formData?.suffix}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">Suffix</FormLabel>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-2">
                <div className="card-body">
                  <div className="row">
                    <legend
                      style={{ fontSize: "Large" }}
                      className="sub-headers"
                    >
                      Link Section
                    </legend>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="url"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Timesheet Link"
                          name="timesheetLink"
                          value={formData?.timesheetLink}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Timesheet Link
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="url"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Vehicle Job Link"
                          name="vehicleJobLink"
                          value={formData?.vehicleJobLink}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Vehicle Job Link
                      </FormLabel>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="url"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Machine Job Link"
                          name="machineJobLink"
                          value={formData?.machineJobLink}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Machine Job Link
                      </FormLabel>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-2">
                <div className="card-body">
                  <div className="row">
                    <legend
                      style={{ fontSize: "Large" }}
                      className="sub-headers"
                    >
                      Zoho Sheet Section
                    </legend>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="url"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Worksheet Link"
                          name="worksheetLink"
                          value={formData?.worksheetLink}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        Worksheet Link
                      </FormLabel>
                    </div>
                  </div>
                  <div className="row">
                    <legend
                      style={{ fontSize: "Large" }}
                      className="sub-headers"
                    >
                      Confirmation Date
                    </legend>
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <div className="search-by-title">
                        <input
                          className="rounded"
                          type="date"
                          style={{ outline: "none", border: "none" }}
                          placeholder="Date"
                          name="confirmationDate"
                          value={formData?.confirmationDate}
                          onChange={handleChange}
                        />
                      </div>
                      <FormLabel className="small-label ps-3">
                        {" "}
                        Confirmation Date
                      </FormLabel>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
              <div className="card mt-2">
                <div className="card-body">
                  <div className="row">
                    <legend
                      style={{ fontSize: "Large" }}
                      className="sub-headers"
                    >
                      Address Information
                    </legend>
                    <div className="row">
                      <div className="col-lg-8 col-md-4 col-sm-12 mb-2">
                        <input
                          className="form-control input-field"
                          type="text"
                          placeholder="street"
                          name="street"
                          value={formData?.street}
                          onChange={handleChange}
                        />
                        <FormLabel className="small-label ps-3">
                          Street
                        </FormLabel>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                        <input
                          className="form-control input-field"
                          type="text"
                          placeholder="city"
                          name="city"
                          value={formData?.city}
                          onChange={handleChange}
                        />
                        <FormLabel className="small-label ps-3">City</FormLabel>
                      </div>

                      <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                        <input
                          className="form-control input-field"
                          type="text"
                          placeholder="state"
                          name="state"
                          value={formData?.state}
                          onChange={handleChange}
                        />
                        <FormLabel className="small-label ps-3">
                          State
                        </FormLabel>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                        <input
                          className="form-control input-field"
                          type="text"
                          placeholder="PinCode"
                          name="PinCode"
                          value={formData?.PinCode}
                          onChange={handleChange}
                        />
                        <FormLabel className="small-label ps-3">
                          PinCode
                        </FormLabel>
                      </div>
                      
                      <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                        <select
                          className="form-select input-field"
                          name="country"
                          value={formData?.country}
                          onChange={handleChange}
                        >
                          <option value="">India</option>
                          <option value="India">India</option>
                        </select>
                        <FormLabel className="small-label ps-3">
                          Country
                        </FormLabel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </DrawerBody>
          <center>
            <DrawerFooter style={{ display: "inline-block" }}>
              <div className="gap-3 d-flex">
                <button
                  variant="outline"
                  mr={3}
                  onClick={handleOnClose}
                  className="cancel-button"
                >
                  Reset
                </button>
                <button
                  className="create-button"
                  onClick={(e) => {
                    !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e);
                  }}
                >
                  {isUpdateMode ? "Update" : "Submit"}
                </button>
              </div>
            </DrawerFooter>
          </center>
        </DrawerContent>
      </Drawer>
    </>
  );
}
export default EmployeeForm;